module.exports = __webpack_public_path__ + "static/media/deepdream.35aae419.jpg";